export default "__VITE_ASSET__DyMAsCGG__"